import androidx.compose.runtime.*
import androidx.compose.runtime.snapshots.SnapshotStateMap
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*

// Dětská sekce: vlastní typy her (NE sdílené s dospělým classic/nine/eight/narubak), aby šly
// mantinelové/dvojicové hry odlišit ve statistikách.
val CHILD_BOWLING_TYPES = listOf(
    "classic" to "Klasika",
    "mantinely" to "S mantinely",
    "dvojice" to "Ve dvojici",
)
fun childBowlingTypeLabel(code: String?): String =
    CHILD_BOWLING_TYPES.firstOrNull { it.first == code }?.second ?: "Klasika"

/** Malý záměrný duplikát ScoreEntryTable (dospělí) typovaný na SgChildDto -- oddělené sekce podle
 *  rozhodnutí, aby úpravy dětské sekce nemohly rozbít zápis skóre dospělým.
 *
 *  Typ hry je zde PER BUŇKA (dítě × hra), ne per sloupec jako u dospělých: v jednom kole může jedno
 *  dítě hrát s mantinely a druhé klasiku ve stejné hře -- gameTypes je proto klíčovaný "childId#gameNo"
 *  (stejně jako scores/sheets), ne jen číslem hry. */
@Composable
fun ChildScoreEntryTable(
    children: List<SgChildDto>,
    games: Int,
    showTypes: Boolean,
    gameTypes: SnapshotStateMap<String, String>,
    defaultType: String,
    scores: SnapshotStateMap<String, String>,
    sheets: SnapshotStateMap<String, List<FrameDto>>,
    onOpenEditor: (key: String, type: String) -> Unit,
    headExtra: (@Composable () -> Unit)? = null,
    rowExtra: (@Composable (SgChildDto) -> Unit)? = null,
) {
    Div(attrs = { classes("stats-table-wrap", "score-entry-wrap") }) {
        Table(attrs = { classes("score-table") }) {
            Thead {
                Tr {
                    Th { Text("Dítě") }
                    headExtra?.let { extra -> Th { extra() } }
                    for (g in 1..games) {
                        Th { Text("hra $g") }
                    }
                }
            }
            Tbody {
                children.forEach { c ->
                    Tr {
                        Td { Text(c.displayName) }
                        rowExtra?.let { extra -> Td { extra(c) } }
                        for (g in 1..games) {
                            val k = "${c.id}#$g"
                            val type = gameTypes[k] ?: defaultType
                            val hasSheet = sheets[k] != null
                            Td {
                                Div(attrs = { classes("score-cell") }) {
                                    Input(type = InputType.Text) {
                                        classes("score-input"); attr("inputmode", "numeric")
                                        if (hasSheet) attr("readonly", "readonly")
                                        value(scores[k] ?: "")
                                        onInput { if (!hasSheet) scores[k] = it.value }
                                    }
                                    if (showTypes) {
                                        Select(attrs = {
                                            classes("type-select")
                                            onChange { ev -> ev.value?.let { gameTypes[k] = it } }
                                        }) {
                                            CHILD_BOWLING_TYPES.forEach { (code, label) ->
                                                Option(code, attrs = { if (type == code) attr("selected", "selected") }) { Text(label) }
                                            }
                                        }
                                    }
                                    Button(attrs = {
                                        classes(*(listOfNotNull("sheet-btn", "sheet-btn-on".takeIf { hasSheet }).toTypedArray()))
                                        attr("title", "Kompletní zápis"); attr("aria-label", "Kompletní zápis")
                                        onClick { onOpenEditor(k, type) }
                                    }) { Text("📝") }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
